import {baseNewImagesPath} from "../assets";

export const iconPlusGreen = `${baseNewImagesPath}images/sqft-icons/cursors/plus_green.png`;
export const iconPlusBlack = `${baseNewImagesPath}images/sqft-icons/cursors/plus_black.png`;
export const iconPlusBlue = `${baseNewImagesPath}images/sqft-icons/cursors/plus_blue.png`;
export const iconplusPurple = `${baseNewImagesPath}images/sqft-icons/cursors/plus_purple.png`;
export const objectFlipVertical = `${baseNewImagesPath}images/sqft-icons/cursors/object_flip_vertical.png`;
export const objectFlipHorizontal = `${baseNewImagesPath}images/sqft-icons/cursors/object_flip_horizontal.png`;
export const iconGreenPlus32 = `${baseNewImagesPath}images/sqft-icons/icon-green-plus-32.png`;
export const iconGreenClip = `${baseNewImagesPath}images/greenclip.svg`;
export const iconHeight = `${baseNewImagesPath}images/sqft-icons/icon-height.svg`;
export const iconLength = `${baseNewImagesPath}images/sqft-icons/icon-length.svg`;
export const iconLink = `${baseNewImagesPath}images/sqft-icons/icon-link.svg`;
export const iconThickness = `${baseNewImagesPath}images/sqft-icons/icon-thickness.svg`;
export const iconEyeball = `${baseNewImagesPath}images/sqft-icons/icon-eyeball.svg`;
export const iconCursorPointer = `${baseNewImagesPath}images/sqft-icons/cursors/pointer.svg`;
export const iconLibrary = `${baseNewImagesPath}images/sqft-icons/icon-length.svg`;
export const iconUpload = `${baseNewImagesPath}images/sqft-icons/icon-upload.svg`;
export const iconImage = `${baseNewImagesPath}images/sqft-icons/icon-image.svg`;

